import TueriProvider from './Provider'
import Img from './Img'

export default TueriProvider
export {
    Img
}